import React, { useContext } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../../template/store';
import { updateNavigateFlag } from '../../../instructionSlice/OverstayExtensionSlice';
import { useBackNavigation } from '../../../../../../../hooks/BackNavigation';
import { AESEncrypt } from '../../../../../../../encrypt-util';
import { useNavigate, useParams } from 'react-router-dom';
import { getReleaseInstructionCountryConfig } from '../../config';
import useBlCountry from '../../../../../../../hooks/useBlCountry';
import { ReleaseInstructionConfigContext } from '../../DoExtension';

interface InvoiceModalProps {
    show: boolean;
    onHide: () => void;
    doExtensionSoftStopConfig: string;
    matchPth: boolean;
    setShowDemurrgaeOrDeliveryModal: (show: boolean) => void;
    formDataInvoiceModal: any;
    onSubmit:()=>void;
    displayNumber:string;
}

const InvoiceModal: React.FC<InvoiceModalProps> = ({ show, onHide, doExtensionSoftStopConfig, matchPth, setShowDemurrgaeOrDeliveryModal,formDataInvoiceModal,onSubmit,displayNumber }) => {
    const dispatch = useDispatch<AppDispatch>();
  const onBack = useBackNavigation();
  const navigate=useNavigate();
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  const { blNum } = useParams();
  const [blCountry] = useBlCountry(
    matchPth ? "view" : "new",
    "import",
    820
  );
  const releaseInstructionConfig=useContext(ReleaseInstructionConfigContext);

    
    const handleInvoiceModalNo = () => {
        dispatch(updateNavigateFlag(false))
        if (doExtensionSoftStopConfig.toLowerCase() == 'no')
            onBack()
        else
            onSubmit()
        setShowDemurrgaeOrDeliveryModal(false)
    }

  const handleInvoiceModalYes = () => {
    // Gather all the form data you want to persist
    


    localStorage.setItem('overstayExtensionFormData', JSON.stringify(formDataInvoiceModal));
    if (!blNum) {
      console.error("Cannot navigate because B/L Number is missing from the URL.");

      return;
    }

    const safeBlNum = encodeURIComponent(blNum);
    const safeDocId = encodeURIComponent(AESEncrypt('816'));
    dispatch(updateNavigateFlag(true))
    navigate(`${APP_PATH_PREFIX}/bl/${safeBlNum}/instruction/${safeDocId}`);
  };

    return (<Modal
        show={show}
        onHide={onHide}
        backdrop
        keyboard={false}
        centered
        animation={false}
    >
        <Modal.Header closeButton>
            {/*  <Modal.Title>Invoice Instruction</Modal.Title> */}
        </Modal.Header>

        <Modal.Body className="text-center">
            <div>
                {releaseInstructionConfig?.fields?.useStorageOverstayMessage ? "Storage Overstay Instruction Invoice Instruction is not submitted for " : "Detention/Demurrage Invoice Instruction is not submitted for "}
                <b>{displayNumber || 'this BL'}</b>.
                <br />
                {releaseInstructionConfig?.fields?.useStorageOverstayMessage ? "Do you want to submit Storage Overstay Instruction? " : "Do you want to submit Detention/Demurrage Invoice Instruction?"}
            </div>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
            <Button variant="secondary" onClick={handleInvoiceModalNo}>
                No
            </Button>
            <Button variant="primary" onClick={handleInvoiceModalYes}>
                Yes
            </Button>
        </Modal.Footer>
    </Modal>);
};

export default InvoiceModal;